<template>
  <nav class="sub__nav">
    <ul>
      <li>
        <a href="/">
          <span class="home__icon">
            <img src="@/assets/images/icon/ic-home.svg" alt="홈 아이콘" />
          </span>
        </a>
      </li>
      <li v-for="item in subNavObj" :key="item.seq">
        <router-link :to="item.link" @click.native="routerParam(item.name)"
          >{{ item.name }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: "Sub-Navigation",
  data() {
    return {
      subNavObj: "",
    };
  },
  watch: {
    $route() {
      this.getRoutePage();
    },
  },
  mounted() {
    this.getRoutePage();
  },
  methods: {
    routerParam(page) {
      switch (page) {
        case "환자현황 대시보드":
          this.$router.push({
            name: "PatientDashboard",
            params: this.$route.params,
          });
          break;
      }
    },
    getRoutePage() {
      this.subNavObj = [];
      this.$route.path.split("/").map((obj) => {
        if (obj !== "") {
          switch (obj) {
            case "dashboard":
              this.subNavObj.push({ link: "/dashboard", name: "대시보드" });
              break;
            case "astop":
              this.subNavObj.push({
                link: "/dashboard/astop",
                name: "알콜중독 치료",
              });
              break;
            case "mstrong":
              this.subNavObj.push({
                link: "/dashboard/mstrong",
                name: "인지장애 치료",
              });
              break;
            case "patientCare":
              this.subNavObj.push({ link: "/patientCare", name: "환자관리" });
              break;
            case "patientInquiry":
              this.subNavObj.push({
                link: "/patientCare/patientInquiry",
                name: "환자조회",
              });
              break;
            case "prescriptionTemplate":
              this.subNavObj.push({
                link: "/patientCare/prescriptionTemplate",
                name: "처방전 템플릿",
              });
              break;
            case "addOrEdit":
              this.subNavObj.push({
                link: "/patientCare/prescriptionTemplate/addOrEdit",
                name: "템플릿 추가/수정",
              });
              break;
            case "prescription":
              this.subNavObj.push({
                link: "/patientCare/patientInquiry/patientDashboard/prescription",
                name: "처방전",
              });
              break;
            case "patientDashboard":
              this.subNavObj.push({
                link: "",
                name: "환자현황 대시보드",
              });
              break;
            case "remedyManagement":
              this.subNavObj.push({
                link: "/remedyManagement",
                name: "치료제 관리",
              });
              break;
            case "remedyInquiry":
              this.subNavObj.push({
                link: "/remedyManagement/remedyInquiry",
                name: "치료제 조회",
              });
              break;
            case "remedyCategory":
              this.subNavObj.push({
                link: "/remedyManagement/remedyCategory",
                name: "카테고리",
              });
              break;
            case "medicineManagement":
              this.subNavObj.push({
                link: "/medicineManagement",
                name: "치료약 관리",
              });
              break;
            case "medicineInquiry":
              this.subNavObj.push({
                link: "/medicineManagement/medicineInquiry",
                name: "치료약 조회",
              });
              break;
            case "addRemedy":
              if (Object.keys(this.$route.query).length > 0) {
                this.subNavObj.push({
                  link: "/remedyManagement/remedyInquiry/addRemedy",
                  name: "치료제 수정",
                });
              } else {
                this.subNavObj.push({
                  link: "/remedyManagement/remedyInquiry/addRemedy",
                  name: "치료제 추가",
                });
              }
              break;
            case "systemManagement":
              this.subNavObj.push({
                link: "/systemManagement",
                name: "시스템 관리",
              });
              break;
            case "permissionManagement":
              this.subNavObj.push({
                link: "/systemManagement/permissionManagement",
                name: "권한 관리",
              });
              break;
            case "commonCodeManagement":
              this.subNavObj.push({
                link: "/systemManagement/commonCodeManagement",
                name: "공통코드 관리",
              });
              break;
            case "functionManagement":
              this.subNavObj.push({
                link: "/systemManagement/functionManagement",
                name: "기능 관리",
              });
              break;
            case "menuManagement":
              this.subNavObj.push({
                link: "/systemManagement/menuManagement",
                name: "메뉴 관리",
              });
              break;
            case "appVersionManagement":
              this.subNavObj.push({
                link: "/systemManagement/appVersionManagement",
                name: "앱 버전 관리",
              });
              break;
            case "userManagement":
              this.subNavObj.push({
                link: "/systemManagement/userManagement",
                name: "유저 관리",
              });
              break;
            case "agencyManagement":
              this.subNavObj.push({
                link: "/systemManagement/agencyManagement",
                name: "기관 관리",
              });
              break;
            case "appLogInquiry":
              this.subNavObj.push({
                link: "/systemManagement/appLogInquiry",
                name: "앱 로그 조회",
              });
              break;
            case "community":
              this.subNavObj.push({
                link: "/community",
                name: "커뮤니티",
              });
              break;
            case "faqManagement":
              this.subNavObj.push({
                link: "/community/faqManagement",
                name: "FAQ",
              });
              break;
            case "qnaManagement":
              this.subNavObj.push({
                link: "/community/qnaManagement",
                name: "Q&A",
              });
              break;
            case "statistical":
              this.subNavObj.push({
                link: "/statistical",
                name: "통계",
              });
              break;
            case "unansweredConsult":
              this.subNavObj.push({
                link: "/unansweredConsult",
                name: "미답변 상담 통계",
              });
              break;
            case "diagnosticResults":
              this.subNavObj.push({
                link: "/diagnosticResults",
                name: "진단결과 통계",
              });
              break;
            case "congnitiveBehavior":
              this.subNavObj.push({
                link: "/congnitiveBehavior",
                name: "인지 행동 변화 통계",
              });
              break;
            case "usageTime":
              this.subNavObj.push({
                link: "/usageTime",
                name: "챗봇 사용 시간",
              });
              break;
          }
        }
      });
    },
  },
};
</script>
